import { render, staticRenderFns } from "./contracts_orders.vue?vue&type=template&id=4b60d2e2&scoped=true"
import script from "./contracts_orders.vue?vue&type=script&lang=js"
export * from "./contracts_orders.vue?vue&type=script&lang=js"
import style0 from "./contracts_orders.vue?vue&type=style&index=0&id=4b60d2e2&prod&scoped=true&lang=scss"
import style1 from "./contracts_orders.vue?vue&type=style&index=1&id=4b60d2e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b60d2e2",
  null
  
)

export default component.exports